D.gtag = function(event, data, userData) {
  if (typeof window.dataLayer === 'undefined') {
    return;
  }
  if (D.DEV) {
    console.log(event, data);
  }
  if (typeof data.ecommerce !== 'undefined') {
    window.dataLayer.push({ecommerce: null});
  }
  data.event = event;
  if(!data.eventId) {
    data.eventId = `${(new Date()).getTime()}.${D.ID}`
  }
  if (typeof userData !== 'undefined') {
    if (typeof window.analytics !== 'undefined') {
      if (userData.lastName) {
        window.analytics.user_name = userData.firstName;
      }
      if (userData.email) {
        window.analytics.user_emai = userData.email;
      }
      if (userData.phone) {
        window.analytics.user_phone = userData.phone;
      }
    }
  }
  window.dataLayer.push(data);
  window.dataLayer.push({ecommerce: null, eventId: null});
  // Send locally
  if (!isset(data.ecommerce)) {
    return;
  }
  if (!D.hasConsent(['analytics_storage', 'ad_storage', 'ad_user_data', 'ad_personalization'])) {
    return;
  }
  if (/Googlebot/i.test(window.navigator.userAgent)) {
    return;
  }
  let ecom = data.ecommerce, m;
  switch (event) {
    case 'add_to_cart':
      m = new DR.analytics.AddToCart();
      break;
    case 'begin_checkout':
      m = new DR.analytics.BeginCheckout();
      break;
    case 'view_item':
      m = new DR.analytics.ViewItem();
      break;
    case 'generate_lead':
      m = new DR.analytics.GenerateLead();
      m.leadSource = ecom.lead_source;
      break;
    case 'search':
      m = new DR.analytics.Search();
      m.searchTerm = ecom.search_term;
      break;
    case 'EmailSignup':
      m = new DR.analytics.EmailSignup();
      break;
    default:
      return;
  }
  m.eventId = data.eventId;
  if(typeof userData !== 'undefined') {
    m.userData = new DR.analytics.struct.UserData;
    if (userData.firstName) {
      m.userData.firstName = userData.firstName;
    }
    if (userData.lastName) {
      m.userData.lastName = userData.lastName;
    }
    if (userData.email) {
      m.userData.email = userData.email;
    }
    if (userData.phone) {
      m.userData.phone = userData.phone;
    }
  }
  if (isset(ecom.currency)) {
    m.currency = ecom.currency.toUpperCase();
  }
  if (isset(ecom.value)) {
    m.value = ecom.value;
  }
  if (ecom.items?.length) {
    m.items = [];
    for (let i = 0; i < ecom.items.length; i++) {
      const item = ecom.items[i];
      m.items.push(
        new DR.analytics.struct.Item({
          'affiliation': item.affiliation,
          'coupon': item.coupon,
          'discount': item.discount,
          'index': item.index,
          'itemId': item.item_id,
          'itemListId': item.item_list_id,
          'itemListName': item.item_list_name,
          'itemName': item.item_name,
          'itemVariant': item.item_variant,
          'locationId': item.location_id,
          'price': item.price,
          'quantity': item.quantity,
        })
      );
    }
  }
  m.call();
};

D.gtagReset = function() {
  if (typeof window.dataLayer === 'undefined') {
    return;
  }
  window.dataLayer.push(function() {
    this.reset();
  });
};

D.branch = function(event, par, data = null) {
  if (D.DEV || typeof window.branch === 'undefined') {
    return;
  }
  window.branch.logEvent(event, par, data);
};

D.capi = function () {};

/**
 * @typedef D.gtag.Pricing.Par
 * @property {String|Null} currency
 * @property {Number|Null} value
 * @property {String|Null} transaction_id
 * @property {String|Null} coupon
 * @property {Number|null} shipping
 * @property {Number|null} tax
 * @property {Number} vat
 * @property {D.gtag.Pricing.Item[]} items
 * @property {Object} custom
 */

/**
 * @typedef D.gtag.Pricing.Item
 * @property {Number|Null} item_id
 * @property {String|Null} item_name
 * @property {String|Null} item_url
 * @property {String|Null} item_image_url
 * @property {String|Null} coupon
 * @property {String|Null} discount
 * @property {Number} price
 * @property {Number} priceVAT
 * @property {Number} quantity
 */

/**
 * @class
 */
D.gtag.Pricing = Class(
    /**
     * @lends {D.gtag.Pricing#}
     */
    {
      /** @type {String} */
      currency: 'eur',
      /** @type {Number} */
      value: 0,
      /** @type {String} */
      transaction_id: '',
      /** @type {String} */
      coupon: '',
      /** @type {Number} */
      shipping: 0,
      /** @type {Number} */
      tax: 0,
      /** @type {Number} */
      vat: 0,
      /** @type {D.gtag.Pricing.Item[]} */
      items: [],
      /** @type {Object} */
      custom: {},
      /**
       * @param {D.gtag.Pricing.Par|null} par
       * @private
       */
      __construct(par = null) {
        if (par !== null) {
          O2O(this, par);
        }
      },
      /** @param {D.gtag.Pricing.Item} item */
      addItem(...item) {
        this.items.push(...item);
        return this;
      },
      /**
       * @param {String} code
       * @param {Number} value
       * @param {Boolean} isPercentage
       */
      applyDiscount(code, value, isPercentage = false) {
        this.coupon = code;
        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];
          if (item._price) {
            item.price = item._price;
          } else {
            item._price = item.price;
          }
          item.coupon = code;
          if (isPercentage) {
            item.discount = value / 100 * item.price;
            item.price -= item.discount;
          } else {
            value = Math.max(0, value);
            if (value > item.price) {
              item.price = 0;
              item.discount = item.price;
            } else {
              item.price = (item.price * item.quantity - value) / item.quantity;
              item.discount = value;
            }
          }
          this.value = Math.max(0, item.price - item.discount);
        }
      },
      add(key, value) {
        this.custom[key] = value;
        return this;
      },
      get() {
        let re = {
          currency: this.currency,
          value: 0,
          valueVAT: 0,
          transaction_id: this.transaction_id,
          coupon: this.coupon,
          shipping: this.shipping,
          tax: 0,
          vat: this.vat,
          items: [],
        };
        for (let i in this.custom) {
          if (this.custom.hasOwnProperty(i)) {
            re[i] = this.custom[i];
          }
        }
        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];
          re.items.push({
            item_id: String(item.item_id),
            item_name: item.item_name,
            item_url: item.item_url || '',
            item_image_url: item.item_image_url || '',
            coupon: item.coupon || '',
            discount: item.discount ? item.discount / 100 : 0,
            price: item.price / 100,
            priceVAT: item.priceVAT / 100,
            quantity: item.quantity
          });
          re.value += item.price * item.quantity / 100;
          re.valueVAT += item.priceVAT * item.quantity / 100;
        }
        re.tax += this.vat / 100 * re.value;
        return re;
      },
      store() {
        let key = this.transaction_id || this.custom.transaction_id;
        if(!key) {
          return false;
        }
        D.gtag.Pricing.setStored(key, JSON.stringify({
          currency: this.currency,
          value: this.value,
          transaction_id: this.transaction_id,
          coupon: this.coupon,
          shipping: this.shipping,
          tax: this.tax,
          vat: this.vat,
          items: this.items,
          custom: this.custom,
        }));
        return true;
      },
      send(type) {
        let eventId = null;
        let ecommerce = this.get();
        switch (type) {
          case 'purchase':
            ecommerce.purchase = true;
            eventId = this.custom.transaction_id;
            break;
          case 'add_to_cart':
            ecommerce.add = true;
            break;
          case 'begin_checkout':
            ecommerce.checkout = true;
            break;
          case 'view_item':
            ecommerce.detail = true;
            break;
        }
        D.gtag(type, {
          ecommerce: ecommerce,
          eventId: eventId
        });
      }
    },
);

D.gtag.Pricing.setStored = function (key, value) {
  D.store.setItem('gtag_pricing_' + key, value);
};

D.gtag.Pricing.getStored = function (key) {
  let par = D.store.getItem('gtag_pricing_' + key);
  if (!par) {
    return null;
  }
  return new D.gtag.Pricing(JSON.parse(par));
};

D.gtag.Pricing.removeStored = function (key) {
  D.store.clear('gtag_pricing_' + key);
};
